<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="url-panel" style="height: unset" @click.stop>
                <div class="dialog-title" v-t="'message.action_show_callback_url'"></div>
                <hr class="dialog-hr">
                <br>
                <div v-if="callbackUrl.length > 0" class="input-form-setting">
                    {{callbackUrl}}<br>
                    <el-button class="dialog-ok-button" style="margin-top: 4pt; margin-bottom: 4pt" type="button" @click="doCopy" v-t="'message.item_copy_url'"></el-button>
                </div>
                <br>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Vue from 'vue';
import server from "./ServerApi.js";
import characterCheck from './charactercheck.js';
import commonUtil from './commonutil.js';
import commonValidate from './common-validate.js';
import constants from './constants.js';

export default {
    data() {
        return {
            callbackUrl: '',
            loadingScreen: null,
        };
    },
    methods: {
        getCallbackUrl() {
            this.loadingScreen = this.$loading({
                    lock: true ,
                    text: 'Loading data ...' ,
                    spinner: 'el-icon-loading' ,
                    background: 'rgba(0, 0, 0, 0)'
            });
            let self = this;
            server.post('/getlineworksv2callbackurl', {})
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            self.callbackUrl = res.data.callbackUrl;
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getCallbackUrl").replace("{code}",res.data.status));
                    }
                    self.closeLoadingScreen();
                })
                .catch( function ( error ) {
                    self.closeLoadingScreen();
                    commonUtil.putExceptionErrorMessage(self, "getCallbackUrl", error);
                });
        },
        closeLoadingScreen() {
            if (this.loadingScreen != null) {
                this.loadingScreen.close();
                this.loadingScreen = null;
            }
        },
        doCopy() {
            if (!this.callbackUrl) {
                alert('failed to copy the URL');
                return;
            }

            navigator.clipboard.writeText(this.callbackUrl)
            .then(() => {
                alert('URL has been copied');
            })
            .catch(e => {
                alert('failed to copy the URL');
            })
        },
    },
    created: function() {
        this.getCallbackUrl();
    },
    components: {
    },
    watch: {
    },
    mounted: function() {
    },
    props: [ 'appData' ]
}
</script scoped>

<style scoped>
.setting-body {
    height:465px;
    padding:0px;
    font-size: 14px;
}
.template-select-button {
    width: 200px;
    margin-top: 15px;
    margin-bottom: 15px;
}
.step-dialog-title >>> .el-step__title {
    font-size: 12px ;
    line-height: 25px ;
}
.step-dialog-title >>> .el-step__head.is-success {
    color: #5171cb;
    border-color: #5171cb;
}
.step-dialog-title >>> .el-step__title.is-success {
    color: #5171cb;
}
.step-dialog-title {
    padding: 20px;
    width: 500px;
}
.item-titlebox {
    width: 100%;
    background-color: #f6f6f6;
    display: table;
    border-bottom: 1px #fff solid;
    margin-top: 10px;
    margin-bottom: 10px;
}
.item-titlebox-left {
    padding: 10px 0 10px 15px;
    width: 50%;
    display: table-cell;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
}
.input-form-setting {
    padding-left: 15px;
    text-align: left;
}
.url-panel {
    background: #fff;
    position: absolute;
    padding: 0;
    left: 40%;
    top: 50%;
    width: 700px;
    max-height: 80vh;
    margin-top: -40vh;
    margin-left: -250px;
    transition: all .3s ease;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    -webkit-overflow-scrolling: touch;
    overflow: hidden;
}



</style>
